import { useNavigate } from "react-router-dom";
import { IContentWithProgress } from "../../../../../@types";
import { useContentAndProgress } from "../../../../../contexts/UserProgressContext";
import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { CircularProgress } from "@mui/material";
import PhaseListModal from "../../components/PhaseListModal";

// const PhaseButtonWrapper = ({
//   isActive,
//   onClick,
//   text,
//   index,
//   dynamicWidth,
// }: {
//   isActive: boolean;
//   onClick: () => void;
//   text: string;
//   index: number;
//   dynamicWidth: number;
// }) => {
//   const width = dynamicWidth;
//   const height = 48;

//   const arrowLength = 17;
//   const heightOffset = 2;

//   const polygonCoords = (idx: number) => {
//     const outerArrow = `${width - arrowLength} ${height - heightOffset}, ${width} ${height / 2}, ${width - arrowLength} ${heightOffset}`;
//     const innerArrow = `0 ${heightOffset}, ${idx == 0 ? `0 ${height / 2}` : `${arrowLength} ${height / 2}`}, 0 ${height - heightOffset}`;
//     return `${innerArrow}, ${outerArrow}`;
//   };

//   return (
//     <div onClick={onClick} className="cursor-pointer ">
//       <svg height={height} width={width}>
//         <polygon
//           points={polygonCoords(index)}
//           stroke={isActive ? "#FDC300" : "black"}
//           fill={isActive ? "#FDC300" : "white"}
//           strokeWidth="1"
//           style={{ transition: 'all 0.3s' }}
//         />
//         <text
//           x={index == 0 ? `${width / 2 - 30}` : `${width / 2 - 22}`}
//           y={`${height / 2 + 5}`}
//           fontSize="12"
//           className={`fill-Black ${isActive ? "font-bold" : "font-[400]"}`}
//         >
//           {text}
//         </text>
//       </svg>
//     </div>
//   );
// };

const PhaseButtonWrapper = ({
  isActive,
  onClick,
  text,
  index,
  dynamicWidth,
}: {
  isActive: boolean;
  onClick: () => void;
  text: string;
  index: number;
  dynamicWidth: number;
}) => {
  const height = 48;
  const roundedWidth = Math.round(dynamicWidth); // Round width for precision

  const firstArrowPath = `M2.5 1C1.39543 1 0.5 1.89543 0.5 3V24V45C0.5 46.1046 1.39543 47 2.5 47H${
    roundedWidth - 17.8727
  }C${roundedWidth - 17.2556} 47 ${roundedWidth - 16.6731} 46.7152 ${
    roundedWidth - 16.2942
  } 46.2281L${roundedWidth - 0.9555} 25.2281C${roundedWidth - 0.3935} 24.5058 ${
    roundedWidth - 0.3935
  } 23.4942 ${roundedWidth - 0.9555} 22.7719L${
    roundedWidth - 16.2942
  } 1.77187C${roundedWidth - 16.6731} 1.28484 ${roundedWidth - 17.2556} 1 ${
    roundedWidth - 17.8727
  } 1H2.5Z`;

  const subsequentArrowPath = `M2.5901 1C${Math.round(
    0.925657 * (roundedWidth / 89)
  )} 1 ${Math.round(-0.010488 * (roundedWidth / 89))} 2.91446 ${Math.round(
    1.01159
  )} 4.22813L${Math.round(15.4392)} 22.7719C${Math.round(
    16.0012
  )} 23.4942 ${Math.round(16.0012)} 24.5058 ${Math.round(
    15.4392
  )} 25.2281L${Math.round(1.01159)} 43.7719C${Math.round(
    -0.0104883
  )} 45.0855 ${Math.round(0.925656)} 47 ${Math.round(2.5901)} 47H${
    roundedWidth - 17.8727
  }C${roundedWidth - 17.2556} 47 ${roundedWidth - 16.6731} 46.7152 ${
    roundedWidth - 16.2942
  } 46.2281L${roundedWidth - 0.9555} 25.2281C${roundedWidth - 0.3935} 24.5058 ${
    roundedWidth - 0.3935
  } 23.4942 ${roundedWidth - 0.9555} 22.7719L${
    roundedWidth - 16.2942
  } 1.77187C${roundedWidth - 16.6731} 1.28484 ${roundedWidth - 17.2556} 1 ${
    roundedWidth - 17.8727
  } 1H2.5901Z`;

  const pathData = index === 0 ? firstArrowPath : subsequentArrowPath;

  return (
    <div onClick={onClick} className="cursor-pointer my-2">
      <svg
        width={roundedWidth}
        height={height}
        viewBox={`0 0 ${roundedWidth} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={pathData}
          fill={isActive ? "#FDC300" : "white"}
          stroke={isActive ? "#FDC300" : "#202119"}
          strokeWidth="1"
          style={{ transition: "all 0.3s" }}
        />
        <text
          x={roundedWidth / 2}
          y={`${height / 2 + 3.5}`}
          textAnchor="middle"
          className={`fill-Black ${
            isActive ? "font-semibold" : "font-[400]"
          } text-[12px] md:text-[14px]`}
        >
          {text}
        </text>
      </svg>
    </div>
  );
};

export function PhasesList({ className }: { className?: string }) {
  const { phases, activePhase, milestones, journey } = useContentAndProgress();
  const { user, configurations } = useContext(AuthContext);
  const productType = configurations?.productType;
  const isBLUE = productType === "BLUE";
  const journeyId = user?.userDetails.journeyId;
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const phaseListRef = useRef<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  const handlePhaseCLick = (phase: IContentWithProgress) => {
    const numberOfPhases = journey?.content.childContentIds.length;

    const phasePosition = phase.content.orderForProgress[journeyId ?? ""] + 1;

    const isLastPhase = phasePosition === numberOfPhases;

    const hasJobType = user?.userDetails?.newJobType;
    const isRestartPhase = phase?.content?.restartPhase;

    if (screenSize < 1024) {
      handleSmallScreenClick(phase);
    } else {
      if (isLastPhase && !hasJobType && isRestartPhase) {
        // Navigate only to the phase page without milestones
        navigate(
          `/phase/${phase.content.platformContentId}/milestone/unlock-phase/content/unlock-phase`
        );
      } else {
        // Normal navigation to first milestone
        const firstMilestone = milestones
          ?.filter((ms: IContentWithProgress) =>
            phase.content.childContentIds.includes(ms.content.platformContentId)
          )
          .sort(
            (ms1: IContentWithProgress, ms2: IContentWithProgress) =>
              ms1.content.orderForProgress[journeyId ?? ""] -
              ms2.content.orderForProgress[journeyId ?? ""]
          )[0];

        navigate(
          `/phase/${phase.content.platformContentId}/milestone/${firstMilestone?.content.platformContentId}`
        );
      }
    }
  };

  const handleSmallScreenClick = (phase: IContentWithProgress) => {
    if (!isBLUE) setIsModalOpen(true);

    const numberOfPhases = journey?.content.childContentIds.length;

    const phasePosition = phase.content.orderForProgress[journeyId ?? ""] + 1;

    const isLastPhase = phasePosition === numberOfPhases;

    const hasJobType = user?.userDetails?.newJobType;
    const isRestartPhase = phase?.content?.restartPhase;

    if (isLastPhase && !hasJobType && isRestartPhase) {
      // Navigate only to the phase page without milestones
      navigate(
        `/phase/${phase.content.platformContentId}/milestone/unlock-phase/content/unlock-phase`
      );
    } else {
      const firstMilestone = milestones
        ?.filter((ms: IContentWithProgress) =>
          phase.content.childContentIds.includes(ms.content.platformContentId)
        )
        .sort(
          (ms1: IContentWithProgress, ms2: IContentWithProgress) =>
            ms1.content.orderForProgress[journeyId ?? ""] -
            ms2.content.orderForProgress[journeyId ?? ""]
        )[0];

      navigate(
        `/phase/${phase.content.platformContentId}/milestone/${firstMilestone?.content.platformContentId}`
      );
    }
  };

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(window.innerWidth);
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  if (!phases || phases.length <= 1) {
    return null;
  }

  return (
    <>
      {isModalOpen && (
        <PhaseListModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      {activePhase ? (
        <div
          ref={phaseListRef}
          className={`w-full flex flex-row justify-between ${className}`}
        >
          {phases?.map((phase: IContentWithProgress, idx: number) => {
            const isActive =
              activePhase?.content.platformContentId ===
              phase.content.platformContentId;
            return (
              <PhaseButtonWrapper
                key={idx}
                isActive={isActive}
                onClick={() => handlePhaseCLick(phase)}
                text={`Phase ${
                  (phase?.content?.orderForProgress[journeyId ?? ""] || 0) + 1
                }`}
                index={idx}
                dynamicWidth={
                  phaseListRef?.current?.offsetWidth / phases.length
                }
              />
            );
          })}
        </div>
      ) : null}
    </>
  );
}
